import { render, staticRenderFns } from "./EventoLogistica.vue?vue&type=template&id=7ffb63e3&scoped=true"
import script from "./EventoLogistica.vue?vue&type=script&lang=js"
export * from "./EventoLogistica.vue?vue&type=script&lang=js"
import style0 from "./EventoLogistica.vue?vue&type=style&index=0&id=7ffb63e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffb63e3",
  null
  
)

export default component.exports